<div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md>
  <div *ngIf="showSideBar">
    <app-movie-page-side-bar class="web-sideBar" (onClose)="openSideBar()"></app-movie-page-side-bar>
  </div>
  <div class="background"
    [ngStyle]="{'background-image': 'linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0)), url(' + movie?.eventImage + ')'}">
    <div class="overlay"></div>
    <div class="content-top-bar">
      <div class="content-container">
        <!--App top bar-->
        <ng-container>
          <div class="sidebar-container">
            <div (click)="openSideBar()" style="cursor: pointer;"><i class="bi bi-list"></i></div>
            <!-- <div (click)="backClicked()" style="cursor: pointer;">
              <i class="bi bi-arrow-left"></i>
            </div> -->
            <div  class="back-arrow"
              (click)="backClicked()">
              <img [src]="leftArrow" alt="leftArrow" />
            </div>
          </div>
          <div class="web-name ">cinejoy</div>
          <div class="container-shop-cart">
            <!-- <app-shopping-cart></app-shopping-cart> -->
          </div>
        </ng-container>

      </div>
      <div class="movie-description-container">
        <div>
          <h1>{{ movie?.name }}</h1>
          <hr width="20px" />
          <div fxLayoutAlign="row" fxLayoutGap="30px" style="font-size: 16px;">
            <div style="font-family: 'Poppins Regular'">Audience Rating: {{ movie?.audienceRating }}/10</div>
            <div>{{ movie?.duration }} mins</div>
          </div>
          <div>
            <p [innerHTML]="movie?.truncatedDescription" id="movie-desc" class="movie-desc">
            </p>
          </div>

          <div>
            <p><i class="bi bi-star-fill"></i> Starring <span
                *ngFor="let cast of movie.casts | slice:0:3; let last = last">
                {{ cast }}{{ last ? '' : ', ' }}
              </span>
            </p>
          </div>
          <div class="button-container">
            <button *ngFor="let button of movie?.tags" class="dynamic-button">
              {{ button }}
            </button>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="10px" style="margin-top: 10px;">
            <button type="button" class="movie_button" *ngIf="movie.showbuybutton && !isBuyButtonActive"
              (click)="open(movie?.eventId, movie, 'Buy')">
              Buy
            </button>
            <button type="button" class="movie_button" *ngIf="movie.showwatchbutton"
              [routerLink]="['/cinejoy/showcase/movie/stream/', movie.eventId,getmovieName(movie.name)]">
              Watch <b>HD</b>
            </button>

            <button type="button" *ngIf="!movie.bookmarked" style="border: none;"
              (click)="bookmarkEvent(movie.eventId, true)">
              <img src="../../../../../assets/images/pass.png" alt="Bookmark Image" width="40px" height="37.5px" />
            </button>

            <button *ngIf="movie.bookmarked" style="border: none;" (click)="alreadyBookmarkEvent(true)">
              <img src="../../../../../assets/images/Bookmarked.png" alt="Bookmark Image" width="40px"
                height="37.5px" />
            </button>

            <button *ngIf="movie.user > 0" type="button" class="movie_button" (click)="openDialogRateMovie()">
              Rate
            </button>
            <!-- <button type="button" class="movie_button" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
              Credits
            </button> -->
            <!-- <button type="button" class="movie_button" *ngIf="checkSpotlightEvent(movie)"
              (click)="navigateToSpolightEvent(movie)">
              Spotlight
            </button> -->
            <button type="button" class="movie_button" *ngIf="checkScreeningPartyEvent(movie)"
              (click)="navigateToScreeningParty()">
              Join Meetup
            </button>
            <button data-bs-toggle="modal" data-bs-target="#shareModal" class="movie_button">
              <i class="bi bi-share-fill" aria-hidden="true"></i>
              <meta name="description" content="Free Web tutorials f">
            </button>
          </div>
        </div>
      </div>
      <img class="waterMarked" [src]="officialLogo" alt="">
    </div>

  </div>
  <div class="description-container">
    <div class="trailer-container">
      <ul class="nav justify-content-center align-items-center">
        <li class="nav-item" (click)="switchTrailerTabs('trailer')">
          <span class="nav-link " [ngClass]="{'active': showTrailer }">Trailer</span>
        </li>
        <li style="color: white;">
          |
        </li>
        <li class="nav-item" (click)="switchTrailerTabs('special')">
          <span class="nav-link" [ngClass]="{'active': showSpecialFeatures }"> Special Feature</span>
        </li>
      </ul>
      <div *ngIf="showTrailer">
        <iframe allowfullscreen="" class="trailer_iframe" frameborder="0" mozallowfullscreen="" [src]="trailerUrl"
          webkitallowfullscreen=""></iframe>
      </div>
      <div *ngIf="showSpecialFeatures">
        <iframe *ngIf="movie?.specialFeature" allowfullscreen="" class="trailer_iframe" frameborder="0"
          mozallowfullscreen="" [src]="splContent" webkitallowfullscreen=""></iframe>
        <div *ngIf="!movie?.specialFeature" style="margin-top: 20%;">
          No Special Features Available
        </div>
      </div>

    </div>
    <div class="list-container">
      <ul class="nav justify-content-start align-items-center" style="margin-left: -15px;">
        <li class="nav-item" (click)="switchCastTabs('cast')">
          <span class="nav-link " [ngClass]="{'active': showCast }">Cast and Crew</span>
        </li>
        <li style="color: white;">
          |
        </li>
        <li class="nav-item" (click)="switchCastTabs('more')">
          <span class="nav-link" [ngClass]="{'active': showMore }">More Info</span>
        </li>
      </ul>
      <div class="artists-container" *ngIf="showCast">
        <div>
          <p class="section-title">Principal Cast</p>
          <span class="crew-list" *ngFor="let cast of movie.casts ; let last = last">
            {{ cast }}{{ last ? '' : ', ' }}
          </span>
        </div>

        <div>
          <p class="section-title">Director(s)</p>
          <span class="crew-list">{{ movie?.directors | extraSpaceAfterComma}}</span>
        </div>

        <div>
          <p class="section-title">Screenwriter(s)</p>
          <span class="crew-list">{{ movie?.screenwriters | extraSpaceAfterComma}}</span>
        </div>


        <div>
          <p class="section-title">Producer(s)</p>
          <span class="crew-list">{{ movie?.producers | extraSpaceAfterComma}}</span>
        </div>
        <div>
          <p class="section-title">Executive Producer(s)</p>
          <span class="crew-list">{{ movie?.executiveproducers | extraSpaceAfterComma}}</span>
        </div>


        <div>
          <p class="section-title">Cinematographer(s)</p>
          <span class="crew-list">{{ movie?.cinematographers | extraSpaceAfterComma}}</span>
        </div>

        <div>
          <p class="section-title">Editor(s)</p>
          <span class="crew-list">{{ movie?.editors | extraSpaceAfterComma}}</span>
        </div>
        <ng-container *ngIf="isExpanded">
          <div>
            <p class="section-title">Production Designer(s)</p>
            <span class="crew-list">{{ movie?.productiondesigners | extraSpaceAfterComma}}</span>
          </div>

          <div>
            <p class="section-title">Music</p>
            <span class="crew-list">{{ movie?.musics | extraSpaceAfterComma}}</span>
          </div>

          <div>
            <p class="section-title">Visual Effects</p>
            <span class="crew-list">{{ movie?.visualeffects | extraSpaceAfterComma}}</span>
          </div>
        </ng-container>
        <div class="read-btn" (click)="toggleContent()">
          <span class="read-more"> {{ isExpanded ? 'Read Less' : 'Read More' }}</span>

        </div>
      </div>
      <div class="artists-container" *ngIf="showMore">
        <div>
          <p class="section-title">Country of Origin</p>
          <span class="crew-list">{{movie?.country | extraSpaceAfterComma }}</span>
        </div>
        <div>
          <p class="section-title">Original Language(s)</p>
          <span class="crew-list">{{movie?.originallanguages | extraSpaceAfterComma}}</span>
        </div>
        <div>
          <p class="section-title">Languages</p>
          <span class="crew-list">{{movie?.language | extraSpaceAfterComma}}</span>
        </div>
        <div>
          <p class="section-title">Subtitles In</p>
          <span class="crew-list">{{movie?.subtitles | extraSpaceAfterComma }}</span>
        </div>
        <div>
          <p class="section-title">Year of Release</p>
          <span class="crew-list">{{movie?.yearofrelease | extraSpaceAfterComma}}</span>
        </div>
      </div>
    </div>

  </div>
  <div fxLayout="row wrap" class="main-container">
    <!-- Instagram Feed Section -->
    <div class="section-container">
      <p class="section-title">Instagram Feed:</p>
      <div class="web-instagram-section">
        <iframe src="https://widget.taggbox.com/2143163" class="responsive-iframe"></iframe>
      </div>
    </div>

    <!-- Community Chat Section -->
    <div class="section-container chat-contianer">
      <p class="section-title">Fan Club, Where Audience and Artists Connect:</p>
      <div class="web-instagram-section" style="z-index: 1;">
        <app-community-chat [eventId]="'showcase-' + id" [eventDetails]="movie"></app-community-chat>
      </div>
    </div>
    <div style="width: 100%;color: white;">
      <div fxLayout="row" fxLayoutAlign="center" *ngIf="movie" style="margin-bottom: 10px !important;">
        <div></div>
        <div class="Social-icon-section" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="30px">
          <span class="follow-label">Follow us on</span>
          <a target="_blank" href="https://www.instagram.com/creaticsorg"><i class="fa fa-instagram fa-3x"
              aria-hidden="true"></i></a>
          <a target="_blank" href="https://www.facebook.com/CreaticsEnterprises"><i class="fa fa-facebook fa-3x"
              aria-hidden="true"></i></a>
          <a target="_blank" href="https://twitter.com/Creatics2"><i class="fa fa-twitter fa-3x"
              aria-hidden="true"></i></a>
        </div>
      </div>
    </div>
  </div>

</div>


<div class="mobile-view" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxHide.gt-lg>
  <div *ngIf="showSideBar">
    <app-movie-page-side-bar class="web-sideBar" (onClose)="onClose()"></app-movie-page-side-bar>
  </div>
  <div fxLayout="row"
    style="justify-content: space-between !important; align-items: center; height: 50px; margin: 5px; color: white; ">
    <div class="" style="font-size: 30px;" (click)="openSideBar()">☰</div>
    <div style=" font-size: 35px; font-family: 'Teko Light';
  color: white;
  text-decoration: none;">cinejoy</div>
    <div class="" style="font-size: 24px;"></div>
  </div>

  <div class="mob-background-img">
    <div class="image-gradient-container">
      <img id="mob-back-arrow" (click)="backClickedMobile()" [src]="backArrow" alt="backArrow" />
      <div id="mob-background-img" alt="" style="background-repeat: no-repeat; 
      background-size: cover; 
      background-position: center; 
      width: 100%;"
        [ngStyle]="{'background-image': 'linear-gradient(to top, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0)), url(' + movie?.mobile_image + ')'}">
      </div>
    </div>
  </div>

  <div class="cinequestLogo" fxLayout="row" [ngClass]="{ 'logo-container': (movie?.name?.length > 25), 'logo-type-container': (movie?.name?.length > 35) }">
    <div class="cinquest-name-container">
      <p class="mob-heading" [ngClass]="{ 'large-text': (movie?.name?.length > 15)}">{{ movie?.name?.trim() }}</p>
      <div fxLayout="row wrap" fxLayoutGap="30px" class="mob-rating-time">
        <div>Audience Rating: <b>{{ movie?.audienceRating }}/10</b></div>
        <div>{{ movie?.duration }} mins</div>
      </div>
    </div>
    <img class="logo" [src]="officialLogo" />
  </div>
  <div class="mobile-content-div">
  
    <div class="mob-credits" style="margin-left: 3%;margin-right: 20px;">
      <div>
        <p [innerHTML]="movie?.truncatedDescription" id="movie-desc1" class="movie-desc">
        </p>
      </div>
    </div>
    <div class="mob-credits">
      <p><i class="bi bi-star-fill"></i> Starring <span *ngFor="let cast of movie.casts | slice:0:3; let last = last">
          {{ cast }}{{ last ? '' : ', ' }}
        </span></p>
    </div>




    <div id="mob-shortDescription">
      <p>
        Official Selection of Cinejoy featuring Cinequest Artists March 24 - March 31, 2025
      </p>
      <div class="mob-button-div" fxLayoutAlign="row wrap" fxLayoutGap="10px">
        <button>{{ movie?.tags[0] }}</button>
        <button>{{ movie?.tags[1] }}</button>
        <button>{{ movie?.tags[2] }}</button>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px" style="justify-content: start;">
        <button type="button" class="mob_movie_button" *ngIf="(movie.showbuybutton && !isBuyButtonActive)"
          (click)="open(movie.eventId, movie, 'Buy')">
          Buy
        </button>
        <button type="button" class="mob_movie_button" *ngIf="movie.showwatchbutton"
          [routerLink]="['/cinejoy/showcase/movie/stream/', movie.eventId, getmovieName(movie.name)]">
          Watch <b>HD</b>
        </button>

        <button type="button" class="mob_movie_button" *ngIf="!movie.bookmarked" style="border: none;"
          (click)="bookmarkEvent(movie.eventId, true)">
          <img src="../../../../../assets/images/mobilepass.png" alt="Bookmark Image" width="40px" height="32px" />
        </button>

        <button *ngIf="movie.bookmarked" class="mob_movie_button" style="border: none;" (click)="alreadyBookmarkEvent(true)">
          <img src="../../../../../assets/images/mobilebookmarked.png" alt="Bookmark Image" width="40px"
            height="32px" />
        </button>

        <button *ngIf="movie.user > 0" type="button" class="mob_movie_button" (click)="openDialogRateMovie()">
          Rate
        </button>
        <!-- <button type="button" class="mob_movie_button" data-bs-toggle="modal" data-bs-target="#staticBackdrop1">
          Credits
        </button> -->
        <button type="button" class="mob_movie_button" *ngIf="checkScreeningPartyEvent(movie)"
          (click)="navigateToScreeningParty()">
          Join Meetup
        </button>
        <button data-bs-toggle="modal" data-bs-target="#shareModal" class="mob_movie_button">
          <i class="bi bi-share-fill" aria-hidden="true"></i>
          <meta name="description">
        </button>
      </div>
      <div class="tabs-container">
        <!-- Normal Images -->
        <img src="../../../../../assets/images/showcase/trailer.png" *ngIf="!isTrailer"
          (click)="tabsControlMobile('trailer')">
        <img src="../../../../../assets/images/showcase/trailer-highlighted.png" [ngClass]="{'highlighted': isTrailer }"  *ngIf="isTrailer"
          (click)="tabsControlMobile('trailer')">

        <img src="../../../../../assets/images/showcase/sp.png" *ngIf="!isSpecialContentMob"
          (click)="tabsControlMobile('sp')">
        <img src="../../../../../assets/images/showcase/sp-highlighted.png"  [ngClass]="{'highlighted': isSpecialContentMob }" *ngIf="isSpecialContentMob"
          (click)="tabsControlMobile('sp')">

        <img src="../../../../../assets/images/showcase/cast.png" *ngIf="!isCastContentMob"
          (click)="tabsControlMobile('cast')">
        <img src="../../../../../assets/images/showcase/cast-highlighted.png" [ngClass]="{'highlighted': isCastContentMob }" *ngIf="isCastContentMob"
          (click)="tabsControlMobile('cast')">

        <img src="../../../../../assets/images/showcase/more-info.png" *ngIf="!isMoreInfoMob"
          (click)="tabsControlMobile('more')">
        <img src="../../../../../assets/images/showcase/more-info-highlighted.png" [ngClass]="{'highlighted': isMoreInfoMob }" *ngIf="isMoreInfoMob"
          (click)="tabsControlMobile('more')">
      </div>
      <div class="mob-video-div">
        <iframe class="mob-trailer-iframe" allowfullscreen="" frameborder="0" mozallowfullscreen="" [src]="trailerUrl"
          webkitallowfullscreen="" *ngIf="isTrailer">
        </iframe>
        <iframe class="mob-trailer-iframe" allowfullscreen="" frameborder="0" mozallowfullscreen="" [src]="splContent"
          webkitallowfullscreen="" *ngIf="isSpecialContentMob">
        </iframe>
        <!-- <iframe *ngIf="movie?.video2" class="mob-short-trailer-iframe" allowfullscreen="" frameborder="0"
          mozallowfullscreen="" [src]="splContent1" webkitallowfullscreen="">
        </iframe> -->
        <div class="artists-container" *ngIf="isCastContentMob">
          <div>
            <p class="section-title">Principal Cast</p>
            <span class="crew-list-mob" *ngFor="let cast of movie.casts; let last = last ">
              {{ cast }}{{ last ? '' : ', ' }}
            </span>
          </div>

          <div>
            <p class="section-title">Director(s)</p>
            <span class="crew-list-mob">{{ movie?.directors | extraSpaceAfterComma}}</span>
          </div>

          <div>
            <p class="section-title">Screenwriter(s)</p>
            <span class="crew-list-mob">{{ movie?.screenwriters | extraSpaceAfterComma}}</span>
          </div>


          <div>
            <p class="section-title">Producer(s)</p>
            <span class="crew-list-mob">{{ movie?.producers | extraSpaceAfterComma}}</span>
          </div>
          <div>
            <p class="section-title">Executive Producer(s)</p>
            <span class="crew-list-mob">{{ movie?.executiveproducers | extraSpaceAfterComma}}</span>
          </div>
          <ng-container>

            <div>
              <p class="section-title">Cinematographer(s)</p>
              <span class="crew-list-mob">{{ movie?.cinematographers | extraSpaceAfterComma}}</span>
            </div>

            <div>
              <p class="section-title">Editor(s)</p>
              <span class="crew-list-mob">{{ movie?.editors | extraSpaceAfterComma}}</span>
            </div>

            <div>
              <p class="section-title">Production Designer(s)</p>
              <span class="crew-list-mob">{{ movie?.productiondesigners | extraSpaceAfterComma}}</span>
            </div>

            <div>
              <p class="section-title">Music</p>
              <span class="crew-list-mob">{{ movie?.musics | extraSpaceAfterComma}}</span>
            </div>

            <div>
              <p class="section-title">Visual Effects</p>
              <span class="crew-list-mob">{{ movie?.visualeffects | extraSpaceAfterComma}}</span>
            </div>
          </ng-container>

        </div>
        <div class="artists-container" *ngIf="isMoreInfoMob">
          <div>
            <p class="section-title">Country of Origin</p>
            <span class="crew-list-mob">{{movie?.country | extraSpaceAfterComma}}</span>
          </div>
          <div>
            <p class="section-title">Original Language(s)</p>
            <span class="crew-list-mob">{{movie?.originallanguages | extraSpaceAfterComma}}</span>
          </div>
          <div>
            <p class="section-title">Languages</p>
            <span class="crew-list-mob">{{movie?.language | extraSpaceAfterComma}}</span>
          </div>
          <div>
            <p class="section-title">Subtitles In</p>
            <span class="crew-list-mob">{{movie?.subtitles | extraSpaceAfterComma}}</span>
          </div>
          <div>
            <p class="section-title">Year of Release</p>
            <span class="crew-list-mob">{{movie?.yearofrelease | extraSpaceAfterComma}}</span>
          </div>
        </div>

        <div style="font-family: 'Poppins Regular' !important;
        font-size: 18px !important;margin-top: 20px;width: 98%;">
          <div>
            <p class="section-title">Fan Club, Where Audience and Artists Connect:</p>
            <app-community-chat-mobile [eventId]="'showcase-' + id" [eventDetails]="movie"></app-community-chat-mobile>
          </div>
        </div>
        <p class="section-title">Instagram Feed:</p>
        <div class="twitter-div" style="height: 80vh;">
          <div class="mob-instagram-section">
            <iframe src="https://widget.taggbox.com/2143163" style="width:100%;height:800px;border:none;"></iframe>
          </div>
        </div>
      </div>
      <div class="mob-footer" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="70px">
        <a target="_blank" href="https://www.instagram.com/creaticsorg"><i class="fa fa-instagram fa-3x"
            aria-hidden="true"></i></a>

        <a target="_blank" href="https://www.facebook.com/CreaticsEnterprises"><i class="fa fa-facebook fa-3x"
            aria-hidden="true"></i></a>
        <a target="_blank" href="https://twitter.com/Creatics2"><i class="fa fa-twitter fa-3x"
            aria-hidden="true"></i></a>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <table>
            <tr>
              Cast:
              <td>
                <div>{{ movie?.casts }}</div>
              </td>
            </tr>
            <tr>
              Director:
              <td>
                <div>{{ movie?.directors }}</div>
              </td>
            </tr>
            <tr>
              Producer:
              <td>
                <div>{{ movie?.producers }}</div>
              </td>
            </tr>
            <tr>
              Writer:
              <td>
                <div>{{ movie?.screenwriters }}</div>
              </td>
            </tr>
            <tr>
              DP:
              <td>
                <div>{{ movie?.cinematographers }}</div>
              </td>
            </tr>
            <tr>
              Editors:
              <td>
                <div>{{ movie?.editors }}</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="movie_button" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <table>
          <tr>
            Cast:
            <td>
              <div>{{ movie?.casts }}</div>
            </td>
          </tr>
          <tr>
            Director:
            <td>
              <div>{{ movie?.directors }}</div>
            </td>
          </tr>
          <tr>
            Producer:
            <td>
              <div>{{ movie?.producers }}</div>
            </td>
          </tr>
          <tr>
            Writer:
            <td>
              <div>{{ movie?.screenwriters }}</div>
            </td>
          </tr>
          <tr>
            DP:
            <td>
              <div>{{ movie?.cinematographers }}</div>
            </td>
          </tr>
          <tr>
            Editors:
            <td>
              <div>{{ movie?.editors }}</div>
            </td>
          </tr>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="movie_button" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>



<!-- Modal Description-->
<div class="modal fade" id="movieDescription"   tabindex="-1"  
  aria-labelledby="staticBackdropLabel" aria-hidden="true" #readmoremodal>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <p>
          <span [innerHTML]="movie?.FullDescription"></span>
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="movie_button" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="shareModal" tabindex="-1" aria-labelledby="shareModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="shareModalLabel">Share</h5>
        <button type="button" data-bs-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body text-center">
        <!-- Share Icons -->
        <div class="row text-center mb-3">
          <div class="col-6 col-md-3 mb-2">
            <button class="btn btn-light w-100" (click)="shareButton('email')" aria-label="Share via Email">
              <i class="bi bi-envelope fs-3"></i><br><span class="small">Email</span>
            </button>
          </div>
          <div class="col-6 col-md-3 mb-2">
            <button class="btn btn-light w-100" (click)="shareButton('facebook')" aria-label="Share on Facebook">
              <i class="bi bi-facebook fs-3"></i><br><span class="small">Facebook</span>
            </button>
          </div>
          <div class="col-6 col-md-3 mb-2">
            <button class="btn btn-light w-100" (click)="shareButton('twitter')" aria-label="Share on Twitter">
              <i class="bi bi-twitter-x fs-3"></i><br><span class="small">X</span>
            </button>
          </div>
          <div class="col-6 col-md-3 mb-2">
            <button class="btn btn-light w-100" (click)="shareButton('instagram')" aria-label="Share on Instagram">
              <i class="bi bi-instagram fs-3"></i><br><span class="small">Instagram</span>
            </button>
          </div>
        </div>
        <!-- Copy Link -->
        <div class="row">
          <div class="col-12">
            <button class="btn btn-secondary w-100 cpy-btn" (click)="shareButton('copy-link')" aria-label="Copy Link">
              Copy link
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>